import React from 'react';
import { Button, Form, Input } from 'antd';
import { AddCardWrapper, Label } from './user.style';
import { useSave } from '../hooks/useSave';
import { CardModel } from 'data/card/card.model';

export const AddCardForm = (props: any) => {
  const { value, onVisibleChange, onSetReloadAfterDrawer } = props;
  const [form] = Form.useForm();

  const { onCardSave } = useSave();

  const handleSubmit = () => {
    const payload: CardModel = {
      card_number: form.getFieldValue('card_number'),
      card_minimum_limit: 0,
      card_pin_number: form.getFieldValue('card_pin_number'),
    };

    onCardSave(value.__user__.id, payload, form, onVisibleChange, onSetReloadAfterDrawer);
  };

  return (
    <AddCardWrapper>
      <Form form={form} name="card-form" layout="vertical" size="large">
        <Form.Item label="Name">
          <Label>{value.__user__.full_name}</Label>
        </Form.Item>
        <Form.Item label="Enter Card Number" name="card_number">
          <Input />
        </Form.Item>
        <Form.Item label="Enter Card Pin Number" name="card_pin_number">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" onClick={handleSubmit}>
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddCardWrapper>
  );
};

export default AddCardForm;
